/**
 * Where a new account lands, and how the tournament it came from rides along.
 *
 * Signup is triggered two ways — from a tournament ("Register" while signed
 * out) and from the nav with no context at all. Both land on /profile; only the
 * first carries enough to draw the reminder banner there. The second is an
 * ordinary outcome, not a missing case.
 *
 * QUERY PARAMS, NOT ROUTER STATE. Router state is dropped on reload, and the
 * banner is the only thing telling a new player they have not actually entered
 * the tournament yet. Losing it to a refresh loses the entry.
 *
 * The tournament LABEL is deliberately not carried. Profile re-reads it from
 * the public API instead: a label taken from the URL is arbitrary text that any
 * link could put in a banner on the player's own profile page.
 */

export const PROFILE_PATH = '/profile';

/** Writes the return trip. Falls back to a bare /profile with no context. */
export function profilePathFor(context) {
  if (!context?.venueSlug || context?.tournamentId == null) return PROFILE_PATH;

  const params = new URLSearchParams({
    venue:      context.venueSlug,
    tournament: String(context.tournamentId),
  });

  return `${PROFILE_PATH}?${params}`;
}

/** Reads back what profilePathFor wrote. Returns null when there is nothing. */
export function readSignupReturn(searchParams) {
  const venueSlug    = searchParams.get('venue');
  const tournamentId = Number(searchParams.get('tournament'));

  if (!venueSlug) return null;
  if (!Number.isInteger(tournamentId) || tournamentId <= 0) return null;

  return { venueSlug, tournamentId };
}
